import { Address, AddressComponent, CustomerLocationComponent, GeoCoordinates, isNullOrUndefined, isNullOrUndefinedOrEmpty, TimeZoneRegion } from 'in-time-core';
import { GeoLocationService } from '../geo-location.service';

export class LocationDataFactory {
  constructor(private readonly geoLocationService: GeoLocationService) {}

  create(): CustomerLocationComponent {
    return new CustomerLocationComponent(
      this.getCustomerAddress(),
      this.getCustomerGeoLocation(),
      this.getCustomerTimeZone(),
    );
  }

  getCustomerAddress(override?: { city?: string | null }): Address | null {
    const region = isNullOrUndefinedOrEmpty(override?.city) ? this.geoLocationService.region : null;
    const city = isNullOrUndefinedOrEmpty(override?.city) ? this.geoLocationService.city : override?.city;

    const countryCode = this.geoLocationService.countryCode;
    const regionComponent = isNullOrUndefined(region) ? null : new AddressComponent(region, region);
    const cityComponent = isNullOrUndefined(city) ? null : new AddressComponent(city, city);

    if(countryCode == null && regionComponent == null && cityComponent == null) {
      return null;
    }

    return new Address(
      countryCode,
      regionComponent,
      null,
      null,
      null,
      null,
      cityComponent,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
    );
  }

  getCustomerGeoLocation(): GeoCoordinates | null {
    const latitude = this.geoLocationService.latitude;
    const longitude = this.geoLocationService.longitude;

    if(isNullOrUndefined(latitude) || isNullOrUndefined(longitude)) {
      return null;
    }

    return new GeoCoordinates(latitude, longitude);
  }

  getCustomerTimeZone(): TimeZoneRegion | null {
    return this.geoLocationService.timezone;
  }
}